<template>
	<div class="main">
		<div v-if="showSummary" class="content_head">
			<div class="content_head_left">
				<img :src="gameData.gameIcon" alt="">
				<div class="content_head_text">
					<p>{{ gameData.gameName }}</p>
					<span>{{ gameData.gameType }}</span>
				</div>
				<!-- <button class="switch_button">切換</button> -->
			</div>
			<div class="content_head_right">
				<p v-if="!hasLogin" class="notLogged">{{ $t('log_in_game_account_text') }} <span class="color"
						v-on:click="openLoginWindow()">, {{ $t('sign_in_lowercase_text') }} >></span></p>
				<div class="content_head_role" v-if="hasLogin">
					<img :src="gameData.gameIcon" alt="">
					<div class="Details">
						<div class="role-meta-row">
							<strong class="role-name">{{ roleInfo.roleName }}</strong>
							<p class="role-id">ID:<span>{{ roleInfo.roleId }}</span></p><i
								v-on:click="openRoleChooseWindow" class="fa account fa-exchange color"></i>
						</div>
						<p class="role-server">Server：<span>{{ roleInfo.serverName }}</span></p>
					</div>
				</div>
			</div>
			<VipMemberHomeCard v-if="isVipEnabled() && hasLogin" :game-data="gameData" />
		</div>
		<div class="game_tips_win">
			<img class="close b-close" src="../assets/image/winclose.png" alt="">
			<img class="imagewin1" :src="gameData.popImage" alt="">
		</div>
		<RoleInfo @init-role-info="initRoleInfo"></RoleInfo>
		<LoginWindow></LoginWindow>
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import RoleInfo from '../components/roleInfo.vue'
import LoginWindow from '../components/loginWindow.vue'
import VipMemberHomeCard from '../components/common/VipMemberHomeCard.vue'
import {
	isEmpty
} from '../utils/index.js'
export default {
	name: 'userInfo',
	props: {
		showSummary: {
			type: Boolean,
			default: true
		},
		showVipCard: {
			type: Boolean,
			default: false
		}
	},
	components: {
		RoleInfo,
		LoginWindow,
		VipMemberHomeCard
	},
	data() {
		return {
			gameData: this.$store.state.gameData,
			roleInfo: this.$cache.getRoleInfo(),
			hasLogin: this.$session.hasLogin()
		}
	},
	mounted() {
		this.importPlugin();
		if (!isEmpty(this.gameData.popImage)) {
			this.autoPop();
		}
		let cacheRoleInfo = this.$cache.getRoleInfo();
		if (isEmpty(cacheRoleInfo) && this.$session.hasLogin()) {
			let _this = this;
			setTimeout(function () {
				_this.openRoleChooseWindow();
			}, 200)
		}
	},
	methods: {
		isVipEnabled:function() {
			const extraFields = this.gameData && this.gameData.extraFields
			return !!extraFields && extraFields.enableVip === true && this.showVipCard == true;
		},
		importPlugin: function () {
			const script = document.createElement('script');
			script.src = '/static/js/jquery.bpopup.js';
			document.head.appendChild(script);
		},
		autoPop: function () {
			if (!this.hasLogin) {
				setTimeout(function () {
					$(".game_tips_win").bPopup();
				}, 500)
			} else if (isEmpty(this.$cache.getAutoPopFlag())) {
				setTimeout(function () {
					$(".game_tips_win").bPopup();
				}, 500)
				this.$cache.setAutoPopFlag();
			}
		},
		initRoleInfo: function (roleInfo) {
			this.roleInfo = roleInfo;
		},
		openRoleChooseWindow: function () {
			$("#roleChooseWindow").bPopup();
		},
		openLoginWindow: function () {
			$("#loginWindow").bPopup();
		},
		viewLevelRewards: function () {
			this.$router.push({ name: 'personalCenter', query: { tab: 'vip' } });
		}
	}
}
</script>

<style scoped>
@media (max-width: 767px) {
	.main .content_head {
		box-sizing: border-box;
		height: auto;
		min-height: 4rem;
		overflow: visible;
		padding: .24rem .28rem .26rem;
	}

	.main .content_head_left {
		position: relative;
		display: grid;
		grid-template-columns: 1.4933rem minmax(0, 1fr);
		column-gap: .24rem;
		width: 100% !important;
		height: auto;
		margin: 0;
	}

	.main .content_head_left img {
		grid-row: 1;
		margin-top: -.72rem;
		margin-left: 0;
	}

	.main .content_head_text {
		width: 100%;
		min-width: 0;
		height: auto;
		margin: 0;
	}

	.main .content_head_text p {
		overflow: visible;
		font-size: .36rem;
		line-height: .46rem;
		text-overflow: clip;
		white-space: normal;
		word-break: break-word;
	}

	.main .content_head_text span {
		position: static;
		display: block;
		margin-top: .06rem;
		overflow: visible;
		font-size: .28rem;
		line-height: .38rem;
		-webkit-line-clamp: unset;
		white-space: normal;
		word-break: break-word;
	}

	.main .content_head .content_head_right {
		position: relative !important;
		right: auto !important;
		left: auto !important;
		top: auto !important;
		box-sizing: border-box;
		width: 100% !important;
		height: auto;
		min-height: 1.32rem;
		margin: .24rem 0 0 !important;
		padding: .18rem .22rem;
		border-radius: .16rem;
		background: #f2f2f2;
	}

	.main .content_head_role {
		display: flex;
		align-items: center;
		width: 100%;
		margin: 0 !important;
		gap: .2rem;
	}

	.main .content_head_role img {
		flex: 0 0 .9rem;
		width: .9rem;
		height: .9rem;
		border-radius: .1rem;
		object-fit: cover;
	}

	.main .Details {
		flex: 1;
		min-width: 0;
		margin: 0 !important;
	}

	.main .Details .role-meta-row {
		align-items: center;
		height: auto;
		min-height: .42rem;
		overflow: visible;
		font-size: .32rem;
		line-height: .42rem;
		gap: .14rem;
	}

	.main .Details .role-name {
		flex: 0 1 auto;
		min-width: 0;
		overflow: hidden;
		color: #292929;
		font-size: .32rem;
		font-weight: 700;
		line-height: .42rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.main .Details div .role-id {
		flex: 1;
		min-width: 0;
		margin: 0;
		overflow: hidden;
		color: #8b8b8b;
		font-size: .24rem;
		line-height: .34rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.main .Details div .role-id span {
		font-size: .24rem;
		color: #8b8b8b;
	}

	.main .Details .fa-exchange {
		flex: 0 0 auto;
	}

	.main .Details .fa-exchange:before {
		font-size: .3rem;
	}

	.main .Details>.role-server {
		margin-top: .08rem;
		overflow: hidden;
		color: #8b8b8b;
		font-size: .26rem;
		line-height: .36rem;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.main .Details>.role-server span {
		font-size: .26rem;
		color: #8b8b8b;
	}

	.main .notLogged {
		line-height: .9rem;
	}
}
</style>
